import { pickBy, isNil, mapValues } from 'lodash';

export const removeEmpty = object => pickBy(object, (value) => !(isNil(value) || value.length === 0));
export const replaceEmptyByNull = object => mapValues(object, (value) => (isNil(value) || value.length === 0) ? null : value);



// WEBPACK FOOTER //
// ./src/helpers/object-helper.js